import { Component, OnInit, HostListener, ViewChild, TemplateRef, Renderer2, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationEnd, Event } from '@angular/router';
import { filter, first } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {MenuService} from '../services/catalogo/menu.service';
import { CatalogoService } from '../services/ecommerce/catalogo.service';
import { CarritoService } from '../services/ecommerce/carrito.service';

@Component({
  selector: 'app-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.css']
})
export class NavHeaderComponent implements OnInit {
  menus: { [key: string]: boolean } = {
    inicio: false,
    vehiculos: false,
    serviciotecnico: false,
    tallermovil: false,
    takata: false,
    tiendavirtual: false,
    usuario: false,
    login: false,
    b2b: false,
  };
  private rutas = new Map<string, string>([
    ['', 'inicio'],
    ['servicio-tecnico', 'serviciotecnico'],
    ['taller-movil', 'tallermovil'],
    ['takata', 'takata'],
    ['tienda-virtual', 'tiendavirtual'],
    ['usuario', 'usuario'],
    ['login', 'login'],
    ['b2b', 'b2b'],
  ]);
  dataCompleta: any = [];
  grupoModelos: any = [];
  itemsGrupo: any = [];
  active = 0;
  topHeader = 0;
  toggle = [true, true, true, true, true];
  isLogin = false;
  /* info del usuario*/
  public userData: any;
  public userJson:any;
  nombreUsuario:string="";
  cantidadCarrito:any;
  sucursalCarrito:any;
  web = true;
  activarCiudad:any;
  ciudadPedido:any;

  /* Ciudad y sucursal del pedido */
  @ViewChild('contentcp') templateRef: TemplateRef<any> | undefined;
  ciudadesTiendas=[];
  dataCompletaBolivia:any=[];
  verCiudad:boolean;
  verMapa=false;

  lat = -17.4911607;
  lng = -63.9826885;
  zoom = 6;

  @ViewChild('fondoMenu') fondoDiv!: ElementRef;
  

  constructor( private router: Router,private modalService: NgbModal, private repuestosService: CatalogoService, private sucursalesService: CatalogoService, private carritoService: CarritoService) {
      this.active = 0;
      this.activarCiudad = false;
      this.verCiudad = false;
  }

  ngOnInit(): void {
    const userData:any = localStorage.getItem('userPlataformaTY');
        this.userJson = JSON.parse(userData);

        if (this.userJson) {
          this.carritoService.cargarCarrito();
        }

        this.carritoService.carrito$.subscribe(data => {
          if (data?.detalle_productos?.length > 0) {
            this.cantidadCarrito = data.detalle_productos.length;
            console.log(this.cantidadCarrito);
            this.sucursalCarrito = data.detalle_productos[0].nombre_sucursal;
            this.ciudadPedido = data.detalle_productos[0].ciudad || '';
          } else {
            
          }
        });


    this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        
        if (event.urlAfterRedirects == "/servicio-tecnico/cotizar-mantenimientos?app=1") {
          this.web = false;
        }
        // Obtener el nombre del componente principal (primer segmento no vacío)
        const segmentos = event.urlAfterRedirects.split('/').filter(segment => segment);
        const nombreComponente = segmentos[0] || 'inicio';
        // Buscar el submenú correspondiente en el mapa
        const subMenu = this.rutas.get(nombreComponente) || 'inicio';
        this.abrirSubMenu(subMenu);
    });
  }
  @HostListener('window:scroll', ['$event'])
  myScroll($event:any) {
    this.topHeader = window.scrollY;

    if(this.topHeader > 0) {
      let elementDOM: any | null = document.getElementById("header");
      elementDOM.style.top = "0px !important";
    }
  }

  onSelectOption(option: any) {
    console.log(`Opción seleccionada: ${option}`);
    this.router.navigate([option]).then(() => {
      window.location.reload();
    });
  }

  

  verciudad() {
    this.openModal(this.templateRef);
  }

  openBackDropCustomClass(content:any) {
    this.modalService.open(content, {backdropClass: 'light-backdrop'});
  }

  enableDisableCiudades(idx:any, opc:any) {

    if ( this.toggle[idx] ) {
      this.toggle[idx] = false;
      let cnt = 0;
      this.toggle.forEach( e => {
        if ( cnt !== idx ) {
          this.toggle[cnt] = true;
        }
        cnt++;
      });
    } else {
      this.toggle[idx] = true;
    }
    setTimeout(() => {
      this.modalService.dismissAll();
    }, 1000);
    
  }

  /* PEDIDOS */

  viewMap() {
    if (this.verMapa) {
      this.verMapa = false;
    } else{
      this.verMapa = true;
    }
  }

  

  openModal(content:any) {
    this.modalService.open(content, { size: 'lg' });
  }

  selectCiudad(event:any){
    const ciudad:any = event.target.value;
    let literal = "";
    for (let ic = 0; ic < this.ciudadesTiendas.length; ic++) {
      if(this.ciudadesTiendas[ic]['id_departamento'] == ciudad){
        literal = ""+this.ciudadesTiendas[ic]['nombre_departamento'];
      }
    }
    
    localStorage.setItem('ciudadECPT', JSON.stringify(ciudad));
    localStorage.setItem('ciudadLiteralECPT', JSON.stringify(literal));
    let userData:any = localStorage.getItem('userPlataformaTY');
    let userJson = JSON.parse(userData);

    if(userJson != null){
      let datos = {
        _method:'PUT',
        id_ciudad:ciudad
      };
      this.repuestosService.postCiudadPedido(datos).subscribe( data => {
  
      }, error => {
          console.log(error);
      });
    } else {
    }
    
    
    this.verificarSucursales();
  }

  verificarSucursales(){
    let ciudadData:any = localStorage.getItem('ciudadECPT');
    let ciudadJson = JSON.parse(ciudadData);

    if(ciudadJson != null){
      this.verCiudad = false;
      this.sucursalesService.getPinesCiudad(ciudadJson).pipe(first()).subscribe(
        data => {
          this.dataCompletaBolivia = data;
        
        }, error => {
        }
      ); 
    } else {
      this.verCiudad = true;
      this.sucursalesService.getCiudadesTiendas().pipe(first()).subscribe(
        data => {
          this.ciudadesTiendas = data;
          this.openModal(this.templateRef);
        }, error => console.log(error)
      );
    }
  }

  
  isMenuOpen(menu: string): boolean {
    return this.menus[menu];
  }

  abrirSubMenu(nombre: string): void {
    Object.keys(this.menus).forEach(key => {
      this.menus[key] = key === nombre;
      //this.menus[key] = key === nombre ? !this.menus[key] : false;
    });
  }
  
}
